<template>
  <div class="ds-unit dialog">
    <div class="content">
      <div
        class="close"
        @click="onClose"
        ></div>
      <div class="title">{{course.name}}</div>
      <div class="main">
        <el-row :gutter="30">
          <el-col :span="7">
            <div class="chapter-record">
              <div class="chapter-record__text">已完成 <span>{{chapterCompleteTotal}}</span> 章节</div>
              <div class="button button--small" @click="onClickStatistics">学习统计</div>
            </div>
          </el-col>
          <el-col :span="17">
            <div class="card card--round tips">
              <template v-if="isChapterView">高分秘籍：先学再记，考核过关再继续。错题回头再练习，真题模拟把分提！</template>
              <template v-if="isExamView">已经考过的试卷，再次点击即可刷新成绩和用时，点击查看报告可以看到你的作答详情。</template>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="30" type="flex">
          <el-col :span="7">
            <div class="collapse">
              <div
                class="collapse__item"
                :class="{'collapse__item--active': isChapterView}"
                data-view="chapter"
                @click="changeView"
              >
                <div class="collapse__head">
                  <div class="collapse__head__title">章节目录</div>
                  <div class="collapse__head__subtitle">共{{chapterTotal}}章</div>
                  <div class="collapse__head__handle collapse__head__handle--active"></div>
                </div>
                <div class="collapse__content">
                  <div class="chapter-list">
                    <!-- eslint-disable max-len -->
                    <div
                      class="chapter-list__item"
                      :class="{
                        'chapter-list__item--active': currentChapter && currentChapter.id === chapter.id,
                        'chapter-list__item--disabled': !chapter.isAvailable
                      }"
                      v-for="chapter in chapterList"
                      :key="chapter.id"
                      @click="selectChapter(chapter)"
                    >
                      {{chapter.name}}
                      <span class="experience" v-if="chapter.isExperienceUnit">快速体验</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="collapse__item"
                :class="{'collapse__item--active': isExamView}"
                data-view="exam"
                @click="changeView"
              >
                <div class="collapse__head collapse__head--active">
                  <div class="collapse__head__title">真题模考</div>
                  <div class="collapse__head__handle"></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col class="el-col--full" :span="17">
            <div class="card card--round chapter-info" v-if="currentView === 'chapter'">
              <div class="chapter-info__status">
                {{section.status ? '已完成本章学习' : '还未完成本章学习'}}
              </div>
              <div class="chapter-info__progress">
                <div class="chapter-info__progress__content">
                  本章共有 <span>{{section.total}}</span> 小节/ <span>{{section.knowledgeTotal}}</span> 个知识点
                </div>
                <div
                  v-if="currentChapter"
                  class="button"
                  @click="onContainer"
                >
                  顺序学习
                </div>
                <div
                  class="button"
                  @click="onChapterExam"
                >
                  章考试
                </div>
                <div
                  class="button button--plain"
                  @click="onClickMoreExam"
                >
                  更多试卷
                </div>
              </div>
              <div
                class="chapter-info__title"
                v-if="section.isHasVideo"
                @click="playVideo({
                  id: currentChapter.id,
                  name: currentChapter.name,
                  isHasKnowledge: currentChapter.isExistKnowledge,
                  isActive: currentChapter.status,
                  isAvailable: currentChapter.isAvailable,
                  video: currentChapter.wkVideo,
                  action: 'chapter'
                })"
              >
                <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/af6bee8c072d72ca64e2b5f3285f93a3.png" alt="观看章节导学" width="24">
                观看章节导学
              </div>
              <div class="chapter-info__score" v-if="section.status">
                章考核 {{section.score}} 分
                <span
                  v-if="isShowReplayExam(section.score)"
                  @click="onChapterExam">去重考 <i class="el-icon-arrow-right"></i></span>
              </div>
              <div class="section-list">
                <div class="section-list__wrapper">
                  <div
                    class="card section-list__item"
                    v-for="item in section.list"
                    :key="item.id"
                  >
                    <el-progress
                      text-inside
                      :stroke-width="18"
                      :percentage="item.progress"
                      color="#5A5FEF"
                    />
                    <div class="section-list__item__name">{{item.name}}</div>
                    <div class="operation">
                      <img
                        v-if="item.wkVideo.length"
                        class="operation__item"
                        src="https://vanthink.oss-cn-qingdao.aliyuncs.com/af6bee8c072d72ca64e2b5f3285f93a3.png"
                        alt="观看章节导学"
                        @click="playVideo({
                          id: item.id,
                          name: item.name,
                          isHasKnowledge: item.isExistKnowledge,
                          isActive: item.status,
                          isAvailable: item.isAvailable,
                          video: item.wkVideo,
                          action: 'section'
                        })"
                        width="18">
                      <a
                        v-if="item.isExistKnowledge"
                        class="operation__item"
                        @click="onLearn(item)"
                      >
                        知识点识记
                      </a>
                      <a
                        class="operation__item"
                        :class="{'operation__item--disabled':!item.status}"
                        @click="onPractice(item)"
                      >
                        同步练习
                      </a>
                      <a
                        class="operation__item"
                        :class="{'operation__item--disabled':!item.status}"
                        @click="onClickMore(item)"
                      >
                        更多练习
                      </a>
                      <router-link
                        title="打印"
                        target="_blank"
                        :to="{
                          name: 'print-exam',
                          query: {
                            sectionId: item.id,
                          },
                        }"
                        class="operation__item">
                        打印
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card--round exam-info" v-if="currentView === 'exam'">
              <div class="card__title">
                真题试卷
                <div class="exam-list-search">
                  <div
                    class="exam-list-search__prefix"
                    @click="onExamSearch"
                  >
                    <i class="el-icon-search"></i>
                  </div>
                  <input
                    class="exam-list-search__input"
                    type="text"
                    placeholder="搜索试卷"
                    v-model="exam.query"
                    @keyup.enter="onExamSearch"
                  />
                </div>
              </div>
              <div class="exam-list">
                <div class="exam-list__wrapper">
                  <template v-if="exam.list.length">
                    <div
                      class="exam-list__item"
                      :class="{'exam-list__item--record': item.time}"
                      v-for="item in exam.list"
                      :key="item.id"
                      @click="onStartExam(item)"
                    >
                      <div class="exam-list__item__name">{{item.name}}</div>
                      <template v-if="item.time">
                        <div class="exam-list__item__time">
                          <span class="iconfont icon-clock"></span> 测试时间：{{item.time || '-'}}
                        </div>
                        <div class="exam-list__item__duration">
                          <span class="iconfont icon-clock"></span> 测试耗时：{{item.duration || '-'}}
                        </div>
                        <div class="exam-list__item__score">{{item.score}}</div>
                        <div
                          class="exam-list__item__button"
                          @click.stop="onViewReport(item)"
                        >
                          查看报告
                        </div>
                      </template>
                    </div>
                    <el-pagination
                      layout="prev, pager, next"
                      :total="exam.total"
                      :page-size="exam.pageSize"
                      @current-change="onPageChange"
                    />
                  </template>
                  <div v-else class="no-data">暂无数据</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 章平行试卷 -->
    <van-dialog
      ref="examDialog"
      append-to-boby
      moda-aAppend-today
    >
      <div class="title" slot="title">更多试卷</div>
      <div class="parallel-exam-list">
        <div class="parallel-exam-list__wrapper">
          <div
            class="parallel-exam-list__item"
            :class="{'exam-list__item--record': item.time}"
            v-for="item in parallelChapterExam.list"
            :key="item.id"
          >
            <div class="parallel-exam-list__item__name">{{item.name}}</div>
            <el-button
              @click="onStartChapterExam(item)"
            >
              开始考试
            </el-button>
          </div>
          <el-pagination
            v-if="parallelChapterExam.total"
            layout="prev, pager, next"
            :total="parallelChapterExam.total"
            :page-size="parallelChapterExam.pageSize"
            @current-change="onChapterExamPageChange"
          />
          <p class="no-data" v-else>暂无数据</p>
        </div>
      </div>
    </van-dialog>
    <!-- 节平行试卷 -->
    <van-dialog
      ref="parallelExamDialog"
      append-to-boby
      moda-aAppend-today
    >
      <div class="title" slot="title">同步练习目录</div>
      <div class="parallel-exam-list">
        <div class="parallel-exam-list__wrapper">
          <div
            class="parallel-exam-list__item"
            :class="{'exam-list__item--record': item.time}"
            v-for="item in parallelExam.list"
            :key="item.id"
          >
            <div class="parallel-exam-list__item__name">{{item.name}}</div>
            <el-button
              @click="onStartChapterExam(item)"
            >
              开始练习
            </el-button>
          </div>
          <el-pagination
            v-if="parallelExam.total"
            layout="prev, pager, next"
            :total="parallelExam.total"
            :page-size="parallelExam.pageSize"
            @current-change="onParallelPageChange"
          />
          <p class="no-data" v-else>暂无数据</p>
        </div>
      </div>
    </van-dialog>
    <!-- 学习统计 -->
    <van-learn-statistics-dialog
      :book-id="course.id"
      ref="statistics"
    />
    <!-- 导学视频 -->
    <van-video-dialog
      v-if="currentChapter"
      ref="learning-video"
      :title="videoTitle"
      :data-catalog-id="currentChapter.id"
      @continue="onVideoContainer"
    />
    <van-dialog
      ref="notAvailable"
      append-to-boby
      moda-aAppend-today
    >
      <div class="title" slot="title">体验结束</div>
      <div class="not-available">
        <p>你表现的太好啦！</p>
        <p>现在停止学习太可惜啦，快联系老师为您开卡继续学习吧！</p>
        <p>使用期间您有任何疑问，请联系相关运营人员。</p>
        <el-button
          @click="closeNotAvailable(item)"
        >
          知道啦
        </el-button>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  Progress,
  Row,
  Col,
  Pagination,
} from 'element-ui';
import api from '@/api/graphql/dsCourse';
import VanVideoDialog from '@/components/quizzes/hk/VideoDialog.vue';
import VanDialog from '@/components/common/Dialog.vue';
import VanLearnStatisticsDialog from '@/components/quizzes/hk/LearnStatisticsDialog.vue';
import utils from '@/services/utils';

export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VanDialog,
    VanVideoDialog,
    VanLearnStatisticsDialog,
    ElPagination: Pagination,
    ElProgress: Progress,
    ElRow: Row,
    ElCol: Col,
  },
  data() {
    return {
      videoTitle: '',
      isChapterActive: true,
      isExamActive: false,
      currentView: 'chapter', // chapter,exam
      chapterList: [], // 章列表
      chapterTotal: 0, // 章总数
      chapterCompleteTotal: 0,
      currentChapter: null, // 当前章
      currentSectionId: 0,
      section: {
        list: [], // 小节列表
        total: 0, // 小节总数
        knowledgeTotal: 0, // 知识点总数
        isHasVideo: 0, // 是否有章导学视频
        score: 0, // 章考核分数
      },
      exam: {
        query: '',
        list: [],
        total: 0,
        pageSize: 3,
        pageNumber: 1,
      },
      parallelExam: {
        query: '',
        list: [],
        total: 0,
        pageSize: 5,
        pageNumber: 1,
      },
      parallelChapterExam: {
        query: '',
        list: [],
        total: 0,
        pageSize: 5,
        pageNumber: 1,
      },
    };
  },
  computed: {
    isExamView() {
      return this.currentView === 'exam';
    },
    isChapterView() {
      return this.currentView === 'chapter';
    },
    isCanChapterExam() {
      return this.section.list.every(item => item.status);
    },
  },
  watch: {
    currentChapter() {
      this.getSectionList();
    },
    show() {
      if (this.show) {
        this.getChapterList();
        this.getExamList();
        if (this.currentChapter) {
          this.getSectionList();
        }
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('close', {
        scene: 'selectCourse',
      });
    },
    onClickStatistics() {
      this.$refs.statistics.open();
    },
    onClickMore(item) {
      if (!item.status) {
        utils.error('您暂未学完前面的内容，请学完再进行同步练习');
        return;
      }

      this.currentSectionId = item.id;
      this.$refs.parallelExamDialog.open();
      this.getParallelExamList(item.id);
    },
    onClickMoreExam() {
      this.getChapterParallelExamList(this.currentChapter.id)
        .then(() => {
          this.$refs.examDialog.open();
        });
    },
    onChange(scene) {
      this.$emit('change', {
        scene,
        params: {
          course: this.course,
          unit: this.currentUnit,
        },
      });
    },
    closeNotAvailable() {
      this.$refs.notAvailable.close();
    },
    selectChapter(chapter) {
      if (!chapter.isAvailable) {
        this.$refs.notAvailable.open();
        return;
      }
      this.currentChapter = chapter;
    },
    changeView(e) {
      const { view } = e.currentTarget.dataset;
      this.currentView = view;
    },
    getChapterList() {
      api
        .getChapterList({
          bookId: this.course.id,
        })
        .then(({ chapterList }) => {
          const { total, completed, list } = chapterList;

          const [defaultChapter] = list;

          if (defaultChapter) {
            if (this.currentChapter) {
              const isExist = utils.Array.exist(list, this.currentChapter, 'id');
              if (!isExist) {
                this.currentChapter = defaultChapter;
              }
            } else {
              this.currentChapter = defaultChapter;
            }
          }
          this.chapterList = list;
          this.chapterTotal = total;
          this.chapterCompleteTotal = completed;
        });
    },
    getSectionList() {
      /* eslint-disable object-curly-newline */
      api
        .getSectionList({
          chapterId: this.currentChapter.id,
        })
        .then(({ sectionList: { list, total, knowledgeTotal, status, score, isHasVideo } }) => {
          this.section.list = list;
          this.section.total = total;
          this.section.status = status;
          this.section.score = score;
          this.section.knowledgeTotal = knowledgeTotal;
          this.section.isHasVideo = isHasVideo;
        });
    },
    onPageChange(pageNumber) {
      this.exam.pageNumber = pageNumber;

      this.getExamList();
    },
    onParallelPageChange(pageNumber) {
      this.parallelExam.pageNumber = pageNumber;
      this.getParallelExamList(this.currentSectionId);
    },
    onChapterExamPageChange(pageNumber) {
      this.parallelChapterExam.pageNumber = pageNumber;

      this.getChapterParallelExamList();
    },
    onExamSearch() {
      this.exam.pageNumber = 1;

      this.getExamList();
    },
    getExamList() {
      api
        .getExamList({
          bookId: this.course.id,
          pageSize: this.exam.pageSize,
          pageNumber: this.exam.pageNumber,
          query: this.exam.query,
        })
        .then(({ examList: { list, total } }) => {
          this.exam.list = list;
          this.exam.total = total;
        });
    },
    getParallelExamList(catalogId) {
      api
        .getParallelExamList({
          catalogId,
          pageSize: this.parallelExam.pageSize,
          pageNumber: this.parallelExam.pageNumber,
          query: this.parallelExam.query,
        })
        .then(({ parallelExamList: { list, total } }) => {
          this.parallelExam.list = list;
          this.parallelExam.total = total;
        });
    },
    getChapterParallelExamList() {
      return api
        .getParallelExamList({
          catalogId: this.currentChapter.id,
          pageSize: this.parallelChapterExam.pageSize,
          pageNumber: this.parallelChapterExam.pageNumber,
          type: 'chapter',
          query: this.parallelChapterExam.query,
        })
        .then(({ parallelExamList: { list, total } }) => {
          this.parallelChapterExam.list = list;
          this.parallelChapterExam.total = total;
        });
    },
    onLearn(section) {
      this.getLearnData({
        type: 'chapter',
        action: 'learn',
        catalogId: section.id,
        payload: section,
      });
    },
    onPractice(section) {
      if (!section.status) {
        utils.error('您暂未学完前面的内容，请学完再进行同步练习');
        return;
      }

      this.getLearnData({
        type: 'chapter',
        action: 'practice',
        catalogId: section.id,
        payload: section,
      });
    },
    onChapterExam() {
      if (!this.isCanChapterExam) {
        utils.error('请完成本章所有同步练习，才能开启章考哦！');
        return;
      }
      this.getLearnData({
        type: 'chapter',
        action: 'section_exam',
        catalogId: this.currentChapter.id,
        payload: this.currentChapter,
      });
    },
    onContainer(section) {
      this.getLearnData({
        type: 'sort',
        action: 'learn',
        catalogId: this.currentChapter.id,
        payload: section,
      });
    },
    onStartExam(exam) {
      this.getLearnData({
        type: 'exam',
        action: 'examination',
        examId: exam.id,
        payload: exam,
      });
    },
    onStartChapterExam(exam) {
      this.getLearnData({
        type: 'parallelExam',
        action: 'examination',
        examId: exam.id,
        payload: exam,
      });
    },
    onViewReport(exam) {
      this.getLearnData({
        type: 'exam',
        action: 'report',
        isExamRecords: 1,
        score: exam.score,
        examId: exam.id,
        payload: exam,
      });
    },
    getLearnData(e, focus) {
      /* eslint-disable */
      const { score, payload, ...params } = e;
      const chapterId = this.currentChapter.id;

      if (params.type === 'chapter' && !focus) {
        this.$refs['learning-video'].playVideo(chapterId, 'pass', {
          ...payload,
          params,
        });
        return;
      }

      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          course: this.course,
          ...params,
          score: score ? Number(score) : 0,
        },
      });
    },
    playVideo(payload) {
      this.videoTitle = payload.name;
      if (payload.action === 'section') {
        this.$refs['learning-video'].playVideo(0, 'section', payload);
      } else {
        this.$refs['learning-video'].playVideo(payload.id);
      }
    },
    onVideoContainer({ params }) {
      this.getLearnData(params, true);
    },
    isShowReplayExam(score) {
      if (window.isNaN(Number(score))) return false;
      return utils.isNumber(Number(score));
    },
  },
  created() {

  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .parallel-exam-list {
    position: relative;
    height: 500px;
    .no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      font-size: 3vh;
      color: $primary;
    }
    &__wrapper {
      position: absolute;
      top: 0;
      right: -12px;
      bottom: 0;
      left: -12px;
      display: flex;
      flex-direction: column;
      padding: 12px;
      overflow-y: auto;
      text-align: center;
    }
    &__item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      text-align: left;
      padding: 16px 20px;
      margin-bottom: 12px;
      box-shadow: 0 0 6px rgba(#5A5FEF, .65);
      border-radius: 12px;
      font-size: 14px;
      overflow: hidden;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      &__name {
        width: 60%;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
</style>

<style lang="scss">
  @import '@/styles/variables.scss';
  .not-available {
    text-align: center;
    color: $primary-light;
    font-size: $font-size-lg;
    font-weight: bold;
    button {
      background: $primary-light;
      color: #fff;
      border-radius: 8px;
    }
  }
  
</style>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import "@/styles/common/dialog.scss";

  .ds-unit {
    width: 160vh;
    height: 90vh;
    .content {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .title {
        padding: 20px 0 20px 20px;
        font-size: 2.4vh;
      }
      .tips {
        line-height: 1.4;
        &:before {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-top: -2px;
          margin-right: 10px;
          vertical-align: middle;
          background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/8c156d859cbd726a2b3fb48befc2df7e.png');
          background-size: 100% 100%;
          content: '';
        }
      }
      .main {
        flex: 1;
        display: flex;
        flex-direction: column;
        border-radius: 24px;
        background-color: #fff;
        padding: 32px;
        color: #5A5FEF;
        > .el-row:nth-child(2) {
          flex: 1;
        }
        .el-row {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .card {
          padding: 18px 24px;
          box-shadow: 0 0 6px rgba(#5A5FEF, .65);
          border-radius: 12px;
          font-size: 16px;
          overflow: hidden;
          &__title {
            position: relative;
            height: 50px;
            line-height: 50px;
            border-radius: 12px;
            cursor: pointer;
            &:before {
              display: inline-block;
              width: 4px;
              height: 12px;
              margin-right: 12px;
              background-color: #5A5FEF;
              border-radius: 2px;
              content: '';
            }
          }
        }
        .collapse {
          display: flex;
          flex-direction: column;
          height: 100%;
          &__item {
            position: relative;
            margin-bottom: 20px;
            box-shadow: 0 0 6px rgba(#5A5FEF, .65);
            border-radius: 12px;
            overflow: hidden;
            &:first-child {
              flex: 1;
            }
            &:last-child {
              margin-bottom: 0;
            }
            &--active {
              .collapse__head {
                border: 2px solid #5A5FEF;
              }
            }
          }
          &__head {
            position: relative;
            height: 50px;
            line-height: 50px;
            border-radius: 12px;
            border: 2px solid rgba(#5A5FEF, .4);
            cursor: pointer;
            &:before {
              display: inline-block;
              width: 4px;
              height: 12px;
              margin-left: 12px;
              background-color: #5A5FEF;
              border-radius: 2px;
              content: '';
            }
            &__title {
              display: inline-block;
              margin: 0 10px;
              font-weight: bold;
              font-size: 18px;
            }
            &__subtitle {
              position: absolute;
              top: 16px;
              right: 60px;
              height: 20px;
              line-height: 20px;
              padding: 0 6px;
              border-radius: 12px;
              font-size: 12px;
              font-weight: normal;
              background-color: rgba(#5A5FEF, .2);
            }
            &__handle {
              position: absolute;
              top: 21px;
              right: 10px;
              width: 16px;
              height: 10px;
              background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/461ecc95a56367801f30f1531d2323db.png');
              background-size: 100% 100%;
              cursor: pointer;
              transform: rotate(-90deg);
              transform-origin: center center;
              &--active {
                transform: rotate(0);
              }
            }
          }
          &__content {
            position: absolute;
            top: 54px;
            right: 0;
            bottom: 0;
            left: 0;
            overflow-y: auto;
          }
        }
        .chapter-info {
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          height: 100%;
          & > div {
            margin-bottom: 20px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          &__status {
            font-size: 16px;
            font-weight: bold;
          }
          &__title {
            font-size: 18px;
            font-weight: bold;
            img {
              vertical-align: bottom;
            }
          }
          &__progress {
            display: flex;
            &__content {
              flex: 1;
              color: #333;
              font-weight: bold;
              span {
                color: #5A5FEF;
              }
            }
          }
          &__score {
            position: absolute;
            right: 32px;
            font-weight: bold;
            font-size: 18px;
            span {
              padding: 4px 6px;
              font-size: 14px;
              color: #fff;
              background-color: #5A5FEF;
              border-radius: 4px;
              cursor: pointer;
              margin-left: 12px;
            }
          }
        }
        .exam-info {
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          height: 100%;
        }
        .section-list {
          flex: 1;
          position: relative;
          &__wrapper {
            position: absolute;
            top: 0;
            right: -12px;
            bottom: 0;
            left: -12px;
            overflow-y: auto;
            padding: 12px;
          }
          &__item {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 20px;
            &:last-child {
              margin-bottom: 0;
            }
            .el-progress {
              width: 100px;
            }
            &__name {
              color: #333;
              width: 180px;
              margin: 0 24px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
        .chapter-list {
          padding: 24px 12px;
          font-size: 16px;
          &__item {
            display: flex;
            align-items: center;
            height: 35px;
            padding: 0 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
            .experience {
              background-color: #e9f7fe;
              color: #4190f7;
              font-size: 12px;
              padding: 2px;
              border-radius: 8px;
              border: 1px solid #4190f7;
              margin-left: 5px;
            }
            &--active {
              background-color: #5A5FEF;
              border-radius: 20px;
              color: #fff;
            }
            &--disabled {
              color: rgba(#333, .2);
              cursor: default;
            }
          }
        }
        .exam-list {
          flex: 1;
          position: relative;
          &__wrapper {
            position: absolute;
            top: 0;
            right: -12px;
            bottom: 0;
            left: -12px;
            display: flex;
            flex-direction: column;
            padding: 12px;
            overflow-y: auto;
          }
          &__item {
            flex: 1;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            min-height: 48px;
            max-height: 22%;
            padding: 16px 12px;
            margin-bottom: 12px;
            box-shadow: 0 0 6px rgba(#5A5FEF, .65);
            border-radius: 12px;
            font-size: 14px;
            overflow: hidden;
            cursor: pointer;
            &:last-child {
              margin-bottom: 0;
            }
            &--record {
              color: #fff;
              background-color: #5A5FEF;
            }
            &__name {
              font-size: 16px;
              font-weight: bold;
            }
            &__duration {}
            &__time {
              margin-top: 10px;
            }
            &__score {
              position: absolute;
              right: 24px;
              font-size: 32px;
              &:after {
                font-size: 16px;
                vertical-align: middle;
                content: '分';
              }
            }
            &__button {
              position: absolute;
              right: 0;
              bottom: 0;
              padding: 3px 24px;
              color: #5A5FEF;
              background-color: #fff;
              border-radius: 12px 0 0 0;
              cursor: pointer;
            }
          }
          .el-pagination {
            text-align: center;
          }
          .no-data {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            font-size: 3vh;
          }
        }
        .exam-list-search {
          position: absolute;
          top: 0;
          right: 0;
          height: 30px;
          line-height: 30px;
          background-color: rgba(#5A5FEF, .2);
          border-radius: 10px;
          overflow: hidden;
          &__prefix {
            display: inline-block;
            width: 50px;
            background-color: #5A5FEF;
            color: #fff;
            text-align: center;
          }
          &__input {
            border: 0;
            padding: 0 10px;
            background-color: transparent;
            outline: none;
          }
        }
        .operation {
          flex: 1;
          font-size: 14px;
          text-align: right;
          img {
            position: relative;
            top: 2px;
          }
          &__item {
            display: inline-block;
            margin: 0 6px;
            color: #5A5FEF;
            cursor: pointer;
            /*vertical-align: text-bottom;*/
            &--disabled {
              color: rgba(#333, .2);
              cursor: default;
            }
            &:first-child {
              margin-left: 0;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .chapter-record {
          position: relative;
          text-align: right;
          height: 54px;
          line-height: 54px;
          color: #333;
          &__text {
            position: absolute;
            left: 0;
          }
          span {
            font-size: 16px;
            color: #5A5FEF;
            font-weight: bold;
          }
        }
        .button {
          display: inline-block;
          width: 100px;
          height: 28px;
          line-height: 28px;
          background-color: #5A5FEF;
          color: #fff;
          margin: 0 6px;
          text-align: center;
          border-radius: 24px;
          border: 2px solid #5A5FEF;
          cursor: pointer;
          &--small {
            font-size: 12px;
            width: 70px;
            height: 22px;
            line-height: 22px;
            border-width: 1px;
          }
          &--plain {
            background-color: rgba(#5A5FEF, .2);
            color: #5A5FEF;
          }
        }
      }
    }
  }
</style>
